import React from 'react';

interface MultiSelectFilterProps {
    label: string;
    options: string[];
    checkedValues: string[];
    onChange: (checked: string[]) => void;
    optionLabel?: (value: string) => string;
}

const MultiSelectFilter: React.FC<MultiSelectFilterProps> = ({
    label,
    options,
    checkedValues,
    onChange,
    optionLabel,
}) => {
    const wrapperRef = React.useRef<HTMLDivElement>(null);
    const [openDropdown, setOpenDropdown] = React.useState(false);

    React.useEffect(() => {
        if (!openDropdown) return;

        const handleClickOutside = (e: MouseEvent) => {
            if (wrapperRef.current && !wrapperRef.current.contains(e.target as Node)) {
                setOpenDropdown(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [openDropdown]);

    const hasActiveFilters = checkedValues.length > 0;

    const toggleOption = (option: string) => {
        const newChecked = checkedValues.includes(option)
            ? checkedValues.filter(v => v !== option)
            : [...checkedValues, option];
        onChange(newChecked);
    };

    return (
        <div className="cg-filter-dropdown-wrapper" ref={wrapperRef}>
            <div
                className={`cg-filter-chip ${hasActiveFilters ? 'active' : ''}`}
                onClick={(e) => {
                    e.stopPropagation();
                    setOpenDropdown(!openDropdown);
                }}
            >
                {label}
                {hasActiveFilters && <span className="badge">{checkedValues.length}</span>}
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" style={{ color: '#94a3b8', marginLeft: '2px' }}>
                    <polyline points="6 9 12 15 18 9"></polyline>
                </svg>
            </div>
            {openDropdown && (
                <div className="cg-filter-menu" onClick={e => e.stopPropagation()}>
                    {options.map(val => (
                        <label key={val} className="cg-filter-item">
                            <input
                                type="checkbox"
                                checked={checkedValues.includes(val)}
                                onChange={() => toggleOption(val)}
                            />
                            {optionLabel ? optionLabel(val) : val}
                        </label>
                    ))}
                </div>
            )}
        </div>
    );
};

export default MultiSelectFilter;
